// ルート定数

export const ROUTES = {
  HOME: '/',
  UPLOAD: '/upload',
  COMPANY_INFO: '/company-info',
  SETTINGS: '/settings',
  INQUIRY: '/inquiry',
  TERMS: '/terms',
  AUTH_ERROR: '/error',
  CREATE_BCP: '/create-bcp',
  CREATE_BCP_INTRO: '/create-bcp-intro',
  RESTORE_POLICY_SIMPLE: '/restore-policy',
  RESTORE_POLICY: (bcpId: string) => `/bcp/${bcpId}/restore-policy`,
  BCP_REGULATION: (bcpId: string) => `/bcp/${bcpId}/regulation`,
  INITIAL_RESPONSE: (bcpId: string) => `/bcp/${bcpId}/initial-response`,
  PROCEDURE_MANUAL: (bcpId: string) => `/bcp/${bcpId}/procedure-manual`,
} as const;

export type Route = typeof ROUTES[keyof typeof ROUTES];
